import type { Pinia } from 'pinia';
import type { SDK, Jwt, RefreshableJwt } from '@tickethead/sdk';
import { parseJwt } from '~/utils/utils';
import { useUserStore, useUserStoreDefinition } from '~/store/user';
import { useSdk } from '~/composables/useSdk';

export function useAuth() {
  const userStore = useUserStore();
  return {
    get loggedIn() {
      return userStore.loggedIn;
    },
    get user() {
      return userStore.user;
    },
    logout: () => useSdk().logout() // store reset happens via the 'logout' listener below
  };
}

export function initAuth(sdk: SDK, pinia: Pinia): void {
  const userStore = useUserStoreDefinition(pinia);

  sdk.eventEmitter.on(
    'authorizationChanged',
    async ({ jwt }: { jwt: Jwt | RefreshableJwt }) => {
      const tokenInfo = parseJwt(jwt?.token);
      if (tokenInfo.id != null) {
        const userData = await sdk.account.getUser({ id: tokenInfo.id });
        userStore.setUser({ ...tokenInfo, ...userData });
      } else if (tokenInfo.guestId != null) {
        // Guest token
        userStore.setUser(tokenInfo);
      }
    }
  );

  sdk.eventEmitter.on('logout', () => userStore.resetUser());
  sdk.eventEmitter.on('credentialsExpired', () => userStore.resetUser());
}
